import React from 'react';
import PropTypes from 'prop-types';
import { Chip } from '@material-ui/core';
import { withStyles } from '@material-ui/styles';
import styles from './styles';

function EstadoChip({ estado = 'SIN ESTADO', classes, ...props }) {
  const className = estado.replace(/_/g, '-').toLowerCase();
  // const label = estado.replace(/_/g, '');
  return (
    <Chip
      {...props}
      size="small"
      label={estado}
      className={classes[className]}
    />
  );
}

EstadoChip.propTypes = {
  estado: PropTypes.string.isRequired,
  classes: PropTypes.objectOf(PropTypes.string).isRequired,
};

EstadoChip.defaultProp = {
  estado: 'SIN ESTADO',
};

export default withStyles(styles)(EstadoChip);
